import { shortMonthNames } from './months';

// Helpers for packed YYYYMM months (202609), the wire format of
// dateutils.YearMonth.

export const yearOf = (month: number): number => Math.floor(month / 100);

export const monthOf = (month: number): number => month % 100;

// monthLabel renders a packed month as "Nov 2024", or the raw number when it
// isn't a valid month.
export function monthLabel(yearMonth: number): string {
  const year = yearOf(yearMonth);
  const month = monthOf(yearMonth);
  if (!year || month < 1 || month > 12) {
    return String(yearMonth);
  }

  return `${shortMonthNames[month - 1]} ${year}`;
}

// currentYearMonth is "now" in the browser's timezone as a packed month. The
// cost-history low callout uses it to exclude forward-posted future months: a
// vendor may post next month's price ahead, but that is not a price the store
// has actually been able to pay.
export function currentYearMonth(): number {
  const now = new Date();

  return now.getFullYear() * 100 + (now.getMonth() + 1);
}

// shiftMonths returns the packed month n months after `month`; n may be negative.
export const shiftMonths = (month: number, n: number): number => {
  const ordinal = yearOf(month) * 12 + (monthOf(month) - 1) + n;

  return Math.floor(ordinal / 12) * 100 + (ordinal % 12) + 1;
};
